import React, { useEffect, useState } from 'react';
import Button from '../../../../../component/ui/Button';
import General from './components/general';
import PreferencesGeneralFieldCustomisation from './components/PreferencesGeneralFieldCustomisation';
import { toast } from 'react-toastify';
import {
	getPreferencesGeneral,
	UpdatePreferencesGeneral,
} from '../../../../../services/settings/preferences';
import { stringToBool } from '../../../../../utils/utility';
import { useDispatch } from 'react-redux';
import { fetchUserInfo } from '../../../../../store/action/userInfo';
import SettingHeaderComponent from '../../components/settingHeaderComponent';

export default function PreferencesGeneral({ activeTab }) {
	const [tab, setTab] = useState('General');
	const [isEdit, setIsEdit] = useState(false);
	const [isCreateForm, setIsCreateForm] = useState(false);
	const [generalLoader, setGeneralLoader] = useState({
		isLoader: true,
		isSave: false,
		isGetData: true,
		isGetDataFieldCustomisation: true,
		isSaveFieldCustomisation: true,
	});
	const [customFieldError, setCustomFieldError] = useState(false);
	const [error, setError] = useState(false);
	const [customFieldForm, setCustomFieldForm] = useState({
		label_name: '',
		data_type: '',
		status: false,
		is_mandatory: false,
	});
	const [general, setGeneral] = useState({});
	const [form, setForm] = useState({
		discount_preferences: '',
		email_attachments: false,
		round_off_preferences: '',
		enable_sales_person: false,
		enable_auto_capitalize_input: false,
		enable_quantity_edit_on_purchase_bill: false,
	});
	const dispatch = useDispatch();
	const getShowUndoChanged = () => {
		const hasChanged = JSON.stringify(general) !== JSON.stringify(form);
		setIsEdit(hasChanged);
	};

	useEffect(() => {
		if (form) {
			getShowUndoChanged();
		}
	}, [form]);

	const handleGeneral = async () => {
		try {
			setIsEdit(false);
			setGeneralLoader((prev) => ({
				...prev,
				isLoader: true,
				isSave: true,
			}));
			const res = await UpdatePreferencesGeneral(form);
			if (res.success) {
				toast.success(res.message);
				dispatch(fetchUserInfo());
				getGeneralDetails();
			} else {
				setIsEdit(true);
				toast.error(res.message || 'something went wrong!');
			}
		} catch (error) {
			setIsEdit(true);
			toast.error(error.message || 'Something went wrong!');
		} finally {
			setGeneralLoader((prev) => ({
				...prev,
				isLoader: false,
				isSave: false,
			}));
		}
	};
	const handleCustomField = () => { };

	const getGeneralDetails = async () => {
		try {
			const { general_settings } = await getPreferencesGeneral();

			const data = {
				discount_preferences:
					general_settings.discount_preferences !== null
						? general_settings.discount_preferences
						: '',
				email_attachments:
					general_settings.email_attachments !== null
						? stringToBool(general_settings.email_attachments)
						: false,
				round_off_preferences:
					general_settings.round_off_preferences !== null
						? general_settings.round_off_preferences
						: '',
				enable_sales_person:
					general_settings.enable_sales_person !== null
						? stringToBool(general_settings.enable_sales_person)
						: false,
				enable_auto_capitalize_input:
					general_settings.enable_auto_capitalize_input !== null
						? stringToBool(general_settings.enable_auto_capitalize_input)
						: false,
				enable_quantity_edit_on_purchase_bill:
					general_settings.enable_quantity_edit_on_purchase_bill !== null
						? stringToBool(general_settings.enable_quantity_edit_on_purchase_bill)
						: false,
			};
			setForm(data);
			setGeneral(data);
		} catch (error) {
			toast.error(error.message || 'Something went wrong!');
		} finally {
			setGeneralLoader((prev) => ({
				...prev,
				isLoader: false,
				isGetData: false,
			}));
		}
	};

	useEffect(() => {
		getGeneralDetails();
	}, []);

	return (
		<div>
			<SettingHeaderComponent
				title={activeTab}
				buttons={tab === 'Field Customisation' ? [
					{
						id: 1,
						button: 'Add New Custom Field',
						add: true,
						close: false,
						disabled: false,
						handler: () => {
							setIsCreateForm(true)
						},
						className: 'btn-primary',
					},

				] : [
					{
						id: 1,
						disabled: !isEdit || generalLoader.isLoader && generalLoader.isSave,
						className: 'btn-primary',
						add: false,
						close: false,
						button: 'Save',
						loader: generalLoader.isLoader && generalLoader.isSave,
						handler: () => {
							handleGeneral();
						},
					},
					isEdit && {
						id: 2,
						disabled: false,
						className: 'btn-primary',
						add: false,
						close: false,
						button: 'Undo Changed',
						handler: () => {
							setIsEdit(false);
							getGeneralDetails();
						},
					}
				].filter((button) => button !== false)}
			/>
			<div
				className="py-2 d-flex justify-content-between align-items-center"
				style={{ backgroundColor: '#DADDEC', position: 'sticky', top: 0, zIndex: 100 }}
			>
				<div>
					<ul className="nav mt-2">
						{['General', 'Field Customisation'].map((item, index) => (
							<li
								key={index}
								className="nav-item"
							>
								<div
									className={`tab-link ${tab === item ? 'active' : ''} d-flex align-items-center`}
									onClick={() => {
										setTab(item);
										setIsCreateForm(false);
									}}
								>
									{item}
								</div>
							</li>
						))}
					</ul>
				</div>
				{isCreateForm && (
					<div className="d-flex gap-4 align-items-center px-2">
						<div
							className="bg-blue py-2 px-4 text-white fs-5 fw-light rounded-4 cursor-pointer"
							style={{ backgroundColor: '#0066ff' }}
							onClick={() => handleCustomField()}
						>
							Save
						</div>
						<div
							className="bg-blue py-2 px-4 text-white fs-5 fw-light rounded-4 cursor-pointer"
							style={{ backgroundColor: '#555B67' }}
							onClick={() => setIsCreateForm(false)}
						>
							Cancel
						</div>
					</div>
				)}
			</div>
			{tab === 'General' ? (
				<General
					form={form}
					setForm={setForm}
					error={error}
					setError={setError}
					generalLoader={generalLoader}
				/>
			) : (
				<PreferencesGeneralFieldCustomisation
					isCreateForm={isCreateForm}
					setIsCreateForm={setIsCreateForm}
					setCustomFieldForm={setCustomFieldForm}
					customFieldForm={customFieldForm}
					setCustomFieldError={setCustomFieldError}
					customFieldError={customFieldError}
				/>
			)}
		</div>
	);
}
